exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".top-20[data-v-5d85666a]{position:fixed;top:20rem}.bottom-20[data-v-5d85666a]{position:fixed;bottom:20rem}@media screen and (max-height:680px){.hide-on-small-height[data-v-5d85666a]{display:none}.col-12-on-small-height[data-v-5d85666a]{margin-left:0!important;-ms-flex:0 0 100%!important;-webkit-box-flex:0!important;flex:0 0 100%!important;max-width:100%!important}}", ""]);

// exports
